/** Interfaces */
import { DsFormTemplateSchemaInterface } from '../interfaces/foms-models/ds-form-template-schema.interface';
/** End Interfaces */

/** Types */
import { DsFormTemplateFieldInterfaceType } from '../types/ds-form-template-field.interface.type';
import { DsFormTemplateFieldType } from '../types/ds-form-template-field.type';
/** End Types */

/** Functions */
import { dsFormsGetTemplateField } from '../functions/ds-forms-get-template-field.function';
/** End Functions */

/** Models */
import { DsFormTemplateTree } from './ds-form-template-tree';
/** End Models */

export class DsFormTemplateSchema {
  /**
   * An array of fields of different types
   */
  fields: DsFormTemplateFieldType[];

  /**
   * Whether to link the form state to the state of the multichoice fields
   */
  linkFormStatusToResult: boolean;

  /**
   * The tree of the form fields
   */
  tree?: DsFormTemplateTree[];

  /**
   * The template form attachments.
   */
  attachments?: string[] = [];

  /**
   * Creates an instance of DsFormTemplateSchema.
   *
   * @param schema the json data
   */
  constructor(schema: DsFormTemplateSchemaInterface) {
    if (schema.fields) {
      let lastAffectedId = this.getLastAffectedId(schema.fieldsSnapshot);
      const fieldsSnapshotHasId = this.checkFieldsHasId(schema.fieldsSnapshot);

      this.fields = schema.fields.map((field, index) => {
        if (!field.id && fieldsSnapshotHasId) {
          field.id = lastAffectedId + 1;
          lastAffectedId += 1;
        } else if (!field.id) {
          field.id = index + 1;
        }
        return dsFormsGetTemplateField(field);
      });
    }
    this.linkFormStatusToResult = schema.linkFormStatusToResult || false;
    this.tree = schema.tree ? schema.tree.map((currentTree) => new DsFormTemplateTree(currentTree)) : [];
    this.attachments = schema.attachments ? schema.attachments.map((attachment) => attachment.hash) : this.attachments;
  }

  /**
   * Checks if we have at least one field with an id.
   *
   * @param fields the form template schema fields
   * @returns number
   */
  checkFieldsHasId(fields: DsFormTemplateFieldInterfaceType[] = []): DsFormTemplateFieldInterfaceType | null {
    return fields ? fields.find((field) => field.id) : null;
  }

  /**
   * Returns last affected fields id.
   *
   * @param fieldsSnapshot the form template schema fields snapshot
   * @returns number
   */
  getLastAffectedId(fieldsSnapshot: DsFormTemplateFieldInterfaceType[] = []): number {
    return fieldsSnapshot && fieldsSnapshot.length > 0 ? Math.max(...fieldsSnapshot.map((field) => field.id)) : null;
  }
}
